

const state = {
    planning: []
};

const getters = {
    allPlanning: (state) => state.planning
};


const actions = {
    
    createPlanning({ commit }, data ) {
        commit('newPlanning', data);
    },
    
    readPlanning({ commit }, data ){
        commit('showPlanning', data);
    },
    
    updatePlanning( { commit }, id){
        commit('changePlanning', id);
    },

    deletePlanning( { commit }, id){
        commit('removePlanning', id);
    },

    
};


const mutations = {
    newPlanning: (state, item) => state.planning.unshift(item),

    showPlanning: (state, item) => state.planning = item,

    changePlanning: (state, item) => {
        const index = state.planning.findIndex(plan => plan.id == item.id);
        if (index !== -1) {
            state.planning.splice(index, 1, item);
        }
    },

    removePlanning: (state, id) => state.planning = state.planning.filter(plan => plan.id !== id),

};


export default {
    state,
    getters,
    actions,
    mutations
};